var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchFile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 28,
    viewBox: "0 0 32 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 28,
    rx: 8,
    fill: "#2487FC",
    fillOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6428 21.5771L18.0705 20.1493C18.5431 20.4749 19.1151 20.6667 19.7324 20.6667C21.3524 20.6667 22.6657 19.3533 22.6657 17.7333C22.6657 16.1133 21.3524 14.8 19.7324 14.8C18.1124 14.8 16.7991 16.1133 16.7991 17.7333C16.7991 18.3507 16.9908 18.9227 17.3164 19.3952L15.8887 20.8229L16.6428 21.5771ZM17.8657 17.7333C17.8657 16.7024 18.7015 15.8667 19.7324 15.8667C20.7633 15.8667 21.5991 16.7024 21.5991 17.7333C21.5991 18.7643 20.7633 19.6 19.7324 19.6C18.7015 19.6 17.8657 18.7643 17.8657 17.7333Z",
    fill: "#2487FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8037 20.4L16.0093 19.1944C15.8272 18.7323 15.7328 18.2387 15.7328 17.7333C15.7328 15.5277 17.5272 13.7333 19.7328 13.7333C20.5173 13.7333 21.248 13.9637 21.8661 14.3555V7.33332C21.8661 7.03865 21.6272 6.79999 21.3328 6.79999H10.6661C10.3717 6.79999 10.1328 7.03865 10.1328 7.33332V19.8667C10.1328 20.1611 10.3717 20.4 10.6661 20.4H14.8037ZM19.9995 11.6H11.9995V10.5333H19.9995V11.6ZM19.9995 9.46665H11.9995V8.39999H19.9995V9.46665Z",
    fill: "#2487FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchFile);
export default __webpack_public_path__ + "static/media/search-file.31181f17a3e1e1bc31e8060f23511a36.svg";
export { ForwardRef as ReactComponent };